/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseQueryOptions,
	UseQueryResult
} from '@tanstack/react-query';

import { customInstance } from '.././instance';
import type { ErrorType } from '.././instance';
import type {
	ApiRequestDetail,
	CasesStatsResponse,
	DashboardOverviewResponse,
	DashboardPoliciesResponse,
	DestinationDeliveriesResponse,
	DestinationHealthSummary,
	DestinationPerformanceResponse,
	GetCasesStatsParams,
	GetDashboardOverviewParams,
	GetDashboardPoliciesParams,
	GetDashboardPolicySparklineParams,
	GetDashboardPraetorSparklineParams,
	GetDestinationDeliveriesParams,
	GetWorkbenchApiRequestsParams,
	GetWorkbenchDestinationHealthParams,
	GetWorkbenchDestinationPerformanceParams,
	GetWorkbenchOverviewParams,
	PraetoidError,
	SparklineResponse,
	WorkbenchApiRequestsResponse,
	WorkbenchOverviewResponse
} from '../models';

/**
 * Returns period/total case counts and timeseries for the overview.
 * @summary Get cases stats
 */
export const getCasesStats = (params: GetCasesStatsParams) => {
	return customInstance<CasesStatsResponse>({
		url: `/analytics/dashboard/cases-stats`,
		method: 'GET',
		params
	});
};

export const getGetCasesStatsQueryKey = (params?: GetCasesStatsParams) => {
	return ['analytics', 'dashboard', 'cases-stats', ...(params ? [params] : [])] as const;
};

export const getGetCasesStatsQueryOptions = <
	TData = Awaited<ReturnType<typeof getCasesStats>>,
	TError = ErrorType<PraetoidError>
>(
	params: GetCasesStatsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCasesStats>>, TError, TData>>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetCasesStatsQueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getCasesStats>>> = () =>
		getCasesStats(params);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getCasesStats>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCasesStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getCasesStats>>>;
export type GetCasesStatsQueryError = ErrorType<PraetoidError>;

export function useGetCasesStats<
	TData = Awaited<ReturnType<typeof getCasesStats>>,
	TError = ErrorType<PraetoidError>
>(
	params: GetCasesStatsParams,
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCasesStats>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getCasesStats>>,
					TError,
					Awaited<ReturnType<typeof getCasesStats>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCasesStats<
	TData = Awaited<ReturnType<typeof getCasesStats>>,
	TError = ErrorType<PraetoidError>
>(
	params: GetCasesStatsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCasesStats>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getCasesStats>>,
					TError,
					Awaited<ReturnType<typeof getCasesStats>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCasesStats<
	TData = Awaited<ReturnType<typeof getCasesStats>>,
	TError = ErrorType<PraetoidError>
>(
	params: GetCasesStatsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCasesStats>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get cases stats
 */

export function useGetCasesStats<
	TData = Awaited<ReturnType<typeof getCasesStats>>,
	TError = ErrorType<PraetoidError>
>(
	params: GetCasesStatsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCasesStats>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetCasesStatsQueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns moderation totals, timeseries, and per-praetor breakdown for the dashboard.
 * @summary Get dashboard overview
 */
export const getDashboardOverview = (params: GetDashboardOverviewParams) => {
	return customInstance<DashboardOverviewResponse>({
		url: `/analytics/dashboard/overview`,
		method: 'GET',
		params
	});
};

export const getGetDashboardOverviewQueryKey = (params?: GetDashboardOverviewParams) => {
	return ['analytics', 'dashboard', 'overview', ...(params ? [params] : [])] as const;
};

export const getGetDashboardOverviewQueryOptions = <
	TData = Awaited<ReturnType<typeof getDashboardOverview>>,
	TError = ErrorType<PraetoidError>
>(
	params: GetDashboardOverviewParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDashboardOverview>>, TError, TData>
		>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetDashboardOverviewQueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardOverview>>> = () =>
		getDashboardOverview(params);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getDashboardOverview>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDashboardOverviewQueryResult = NonNullable<
	Awaited<ReturnType<typeof getDashboardOverview>>
>;
export type GetDashboardOverviewQueryError = ErrorType<PraetoidError>;

export function useGetDashboardOverview<
	TData = Awaited<ReturnType<typeof getDashboardOverview>>,
	TError = ErrorType<PraetoidError>
>(
	params: GetDashboardOverviewParams,
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDashboardOverview>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getDashboardOverview>>,
					TError,
					Awaited<ReturnType<typeof getDashboardOverview>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDashboardOverview<
	TData = Awaited<ReturnType<typeof getDashboardOverview>>,
	TError = ErrorType<PraetoidError>
>(
	params: GetDashboardOverviewParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDashboardOverview>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getDashboardOverview>>,
					TError,
					Awaited<ReturnType<typeof getDashboardOverview>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDashboardOverview<
	TData = Awaited<ReturnType<typeof getDashboardOverview>>,
	TError = ErrorType<PraetoidError>
>(
	params: GetDashboardOverviewParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDashboardOverview>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get dashboard overview
 */

export function useGetDashboardOverview<
	TData = Awaited<ReturnType<typeof getDashboardOverview>>,
	TError = ErrorType<PraetoidError>
>(
	params: GetDashboardOverviewParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDashboardOverview>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetDashboardOverviewQueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns policy violation breakdown ranked by count.
 * @summary Get dashboard policy violations
 */
export const getDashboardPolicies = (params: GetDashboardPoliciesParams) => {
	return customInstance<DashboardPoliciesResponse>({
		url: `/analytics/dashboard/policies`,
		method: 'GET',
		params
	});
};

export const getGetDashboardPoliciesQueryKey = (params?: GetDashboardPoliciesParams) => {
	return ['analytics', 'dashboard', 'policies', ...(params ? [params] : [])] as const;
};

export const getGetDashboardPoliciesQueryOptions = <
	TData = Awaited<ReturnType<typeof getDashboardPolicies>>,
	TError = ErrorType<PraetoidError>
>(
	params: GetDashboardPoliciesParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDashboardPolicies>>, TError, TData>
		>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetDashboardPoliciesQueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardPolicies>>> = () =>
		getDashboardPolicies(params);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getDashboardPolicies>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDashboardPoliciesQueryResult = NonNullable<
	Awaited<ReturnType<typeof getDashboardPolicies>>
>;
export type GetDashboardPoliciesQueryError = ErrorType<PraetoidError>;

export function useGetDashboardPolicies<
	TData = Awaited<ReturnType<typeof getDashboardPolicies>>,
	TError = ErrorType<PraetoidError>
>(
	params: GetDashboardPoliciesParams,
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDashboardPolicies>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getDashboardPolicies>>,
					TError,
					Awaited<ReturnType<typeof getDashboardPolicies>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDashboardPolicies<
	TData = Awaited<ReturnType<typeof getDashboardPolicies>>,
	TError = ErrorType<PraetoidError>
>(
	params: GetDashboardPoliciesParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDashboardPolicies>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getDashboardPolicies>>,
					TError,
					Awaited<ReturnType<typeof getDashboardPolicies>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDashboardPolicies<
	TData = Awaited<ReturnType<typeof getDashboardPolicies>>,
	TError = ErrorType<PraetoidError>
>(
	params: GetDashboardPoliciesParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDashboardPolicies>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get dashboard policy violations
 */

export function useGetDashboardPolicies<
	TData = Awaited<ReturnType<typeof getDashboardPolicies>>,
	TError = ErrorType<PraetoidError>
>(
	params: GetDashboardPoliciesParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDashboardPolicies>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetDashboardPoliciesQueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns violation counts for a specific policy. Hourly buckets for ranges <= 48h, daily otherwise.
 * @summary Get policy sparkline
 */
export const getDashboardPolicySparkline = (
	policyId: string,
	params: GetDashboardPolicySparklineParams
) => {
	return customInstance<SparklineResponse>({
		url: `/analytics/dashboard/policies/${policyId}/sparkline`,
		method: 'GET',
		params
	});
};

export const getGetDashboardPolicySparklineQueryKey = (
	policyId: string,
	params?: GetDashboardPolicySparklineParams
) => {
	return [
		'analytics',
		'dashboard',
		'policies',
		policyId,
		'sparkline',
		...(params ? [params] : [])
	] as const;
};

export const getGetDashboardPolicySparklineQueryOptions = <
	TData = Awaited<ReturnType<typeof getDashboardPolicySparkline>>,
	TError = ErrorType<PraetoidError>
>(
	policyId: string,
	params: GetDashboardPolicySparklineParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDashboardPolicySparkline>>, TError, TData>
		>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetDashboardPolicySparklineQueryKey(policyId, params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardPolicySparkline>>> = () =>
		getDashboardPolicySparkline(policyId, params);

	return { queryKey, queryFn, enabled: !!policyId, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getDashboardPolicySparkline>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDashboardPolicySparklineQueryResult = NonNullable<
	Awaited<ReturnType<typeof getDashboardPolicySparkline>>
>;
export type GetDashboardPolicySparklineQueryError = ErrorType<PraetoidError>;

export function useGetDashboardPolicySparkline<
	TData = Awaited<ReturnType<typeof getDashboardPolicySparkline>>,
	TError = ErrorType<PraetoidError>
>(
	policyId: string,
	params: GetDashboardPolicySparklineParams,
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDashboardPolicySparkline>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getDashboardPolicySparkline>>,
					TError,
					Awaited<ReturnType<typeof getDashboardPolicySparkline>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDashboardPolicySparkline<
	TData = Awaited<ReturnType<typeof getDashboardPolicySparkline>>,
	TError = ErrorType<PraetoidError>
>(
	policyId: string,
	params: GetDashboardPolicySparklineParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDashboardPolicySparkline>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getDashboardPolicySparkline>>,
					TError,
					Awaited<ReturnType<typeof getDashboardPolicySparkline>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDashboardPolicySparkline<
	TData = Awaited<ReturnType<typeof getDashboardPolicySparkline>>,
	TError = ErrorType<PraetoidError>
>(
	policyId: string,
	params: GetDashboardPolicySparklineParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDashboardPolicySparkline>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get policy sparkline
 */

export function useGetDashboardPolicySparkline<
	TData = Awaited<ReturnType<typeof getDashboardPolicySparkline>>,
	TError = ErrorType<PraetoidError>
>(
	policyId: string,
	params: GetDashboardPolicySparklineParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDashboardPolicySparkline>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetDashboardPolicySparklineQueryOptions(policyId, params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns daily case counts for a specific praetor.
 * @summary Get praetor sparkline
 */
export const getDashboardPraetorSparkline = (
	praetorId: string,
	params: GetDashboardPraetorSparklineParams
) => {
	return customInstance<SparklineResponse>({
		url: `/analytics/dashboard/praetors/${praetorId}/sparkline`,
		method: 'GET',
		params
	});
};

export const getGetDashboardPraetorSparklineQueryKey = (
	praetorId: string,
	params?: GetDashboardPraetorSparklineParams
) => {
	return [
		'analytics',
		'dashboard',
		'praetors',
		praetorId,
		'sparkline',
		...(params ? [params] : [])
	] as const;
};

export const getGetDashboardPraetorSparklineQueryOptions = <
	TData = Awaited<ReturnType<typeof getDashboardPraetorSparkline>>,
	TError = ErrorType<PraetoidError>
>(
	praetorId: string,
	params: GetDashboardPraetorSparklineParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDashboardPraetorSparkline>>, TError, TData>
		>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetDashboardPraetorSparklineQueryKey(praetorId, params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardPraetorSparkline>>> = () =>
		getDashboardPraetorSparkline(praetorId, params);

	return { queryKey, queryFn, enabled: !!praetorId, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getDashboardPraetorSparkline>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDashboardPraetorSparklineQueryResult = NonNullable<
	Awaited<ReturnType<typeof getDashboardPraetorSparkline>>
>;
export type GetDashboardPraetorSparklineQueryError = ErrorType<PraetoidError>;

export function useGetDashboardPraetorSparkline<
	TData = Awaited<ReturnType<typeof getDashboardPraetorSparkline>>,
	TError = ErrorType<PraetoidError>
>(
	praetorId: string,
	params: GetDashboardPraetorSparklineParams,
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDashboardPraetorSparkline>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getDashboardPraetorSparkline>>,
					TError,
					Awaited<ReturnType<typeof getDashboardPraetorSparkline>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDashboardPraetorSparkline<
	TData = Awaited<ReturnType<typeof getDashboardPraetorSparkline>>,
	TError = ErrorType<PraetoidError>
>(
	praetorId: string,
	params: GetDashboardPraetorSparklineParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDashboardPraetorSparkline>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getDashboardPraetorSparkline>>,
					TError,
					Awaited<ReturnType<typeof getDashboardPraetorSparkline>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDashboardPraetorSparkline<
	TData = Awaited<ReturnType<typeof getDashboardPraetorSparkline>>,
	TError = ErrorType<PraetoidError>
>(
	praetorId: string,
	params: GetDashboardPraetorSparklineParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDashboardPraetorSparkline>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get praetor sparkline
 */

export function useGetDashboardPraetorSparkline<
	TData = Awaited<ReturnType<typeof getDashboardPraetorSparkline>>,
	TError = ErrorType<PraetoidError>
>(
	praetorId: string,
	params: GetDashboardPraetorSparklineParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDashboardPraetorSparkline>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetDashboardPraetorSparklineQueryOptions(praetorId, params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns a paginated reverse-chronological list of API requests for the current org/environment.
 * @summary List API requests
 */
export const getWorkbenchApiRequests = (params?: GetWorkbenchApiRequestsParams) => {
	return customInstance<WorkbenchApiRequestsResponse>({
		url: `/analytics/workbench/api_requests`,
		method: 'GET',
		params
	});
};

export const getGetWorkbenchApiRequestsQueryKey = (params?: GetWorkbenchApiRequestsParams) => {
	return ['analytics', 'workbench', 'api_requests', ...(params ? [params] : [])] as const;
};

export const getGetWorkbenchApiRequestsQueryOptions = <
	TData = Awaited<ReturnType<typeof getWorkbenchApiRequests>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetWorkbenchApiRequestsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getWorkbenchApiRequests>>, TError, TData>
		>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetWorkbenchApiRequestsQueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkbenchApiRequests>>> = () =>
		getWorkbenchApiRequests(params);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getWorkbenchApiRequests>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetWorkbenchApiRequestsQueryResult = NonNullable<
	Awaited<ReturnType<typeof getWorkbenchApiRequests>>
>;
export type GetWorkbenchApiRequestsQueryError = ErrorType<PraetoidError>;

export function useGetWorkbenchApiRequests<
	TData = Awaited<ReturnType<typeof getWorkbenchApiRequests>>,
	TError = ErrorType<PraetoidError>
>(
	params: undefined | GetWorkbenchApiRequestsParams,
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getWorkbenchApiRequests>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getWorkbenchApiRequests>>,
					TError,
					Awaited<ReturnType<typeof getWorkbenchApiRequests>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetWorkbenchApiRequests<
	TData = Awaited<ReturnType<typeof getWorkbenchApiRequests>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetWorkbenchApiRequestsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getWorkbenchApiRequests>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getWorkbenchApiRequests>>,
					TError,
					Awaited<ReturnType<typeof getWorkbenchApiRequests>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetWorkbenchApiRequests<
	TData = Awaited<ReturnType<typeof getWorkbenchApiRequests>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetWorkbenchApiRequestsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getWorkbenchApiRequests>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List API requests
 */

export function useGetWorkbenchApiRequests<
	TData = Awaited<ReturnType<typeof getWorkbenchApiRequests>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetWorkbenchApiRequestsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getWorkbenchApiRequests>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetWorkbenchApiRequestsQueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns metadata plus signed URLs for the captured request and response bodies. URLs expire in 5 minutes.
 * @summary Get API request detail
 */
export const getWorkbenchApiRequest = (eventId: string) => {
	return customInstance<ApiRequestDetail>({
		url: `/analytics/workbench/api_requests/${eventId}`,
		method: 'GET'
	});
};

export const getGetWorkbenchApiRequestQueryKey = (eventId: string) => {
	return ['analytics', 'workbench', 'api_requests', eventId] as const;
};

export const getGetWorkbenchApiRequestQueryOptions = <
	TData = Awaited<ReturnType<typeof getWorkbenchApiRequest>>,
	TError = ErrorType<PraetoidError>
>(
	eventId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getWorkbenchApiRequest>>, TError, TData>
		>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetWorkbenchApiRequestQueryKey(eventId);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkbenchApiRequest>>> = () =>
		getWorkbenchApiRequest(eventId);

	return { queryKey, queryFn, enabled: !!eventId, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getWorkbenchApiRequest>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetWorkbenchApiRequestQueryResult = NonNullable<
	Awaited<ReturnType<typeof getWorkbenchApiRequest>>
>;
export type GetWorkbenchApiRequestQueryError = ErrorType<PraetoidError>;

export function useGetWorkbenchApiRequest<
	TData = Awaited<ReturnType<typeof getWorkbenchApiRequest>>,
	TError = ErrorType<PraetoidError>
>(
	eventId: string,
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getWorkbenchApiRequest>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getWorkbenchApiRequest>>,
					TError,
					Awaited<ReturnType<typeof getWorkbenchApiRequest>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetWorkbenchApiRequest<
	TData = Awaited<ReturnType<typeof getWorkbenchApiRequest>>,
	TError = ErrorType<PraetoidError>
>(
	eventId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getWorkbenchApiRequest>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getWorkbenchApiRequest>>,
					TError,
					Awaited<ReturnType<typeof getWorkbenchApiRequest>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetWorkbenchApiRequest<
	TData = Awaited<ReturnType<typeof getWorkbenchApiRequest>>,
	TError = ErrorType<PraetoidError>
>(
	eventId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getWorkbenchApiRequest>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get API request detail
 */

export function useGetWorkbenchApiRequest<
	TData = Awaited<ReturnType<typeof getWorkbenchApiRequest>>,
	TError = ErrorType<PraetoidError>
>(
	eventId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getWorkbenchApiRequest>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetWorkbenchApiRequestQueryOptions(eventId, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns individual delivery attempts for a specific destination.
 * @summary Get destination delivery attempts
 */
export const getDestinationDeliveries = (
	destinationId: string,
	params?: GetDestinationDeliveriesParams
) => {
	return customInstance<DestinationDeliveriesResponse>({
		url: `/analytics/workbench/destinations/${destinationId}/deliveries`,
		method: 'GET',
		params
	});
};

export const getGetDestinationDeliveriesQueryKey = (
	destinationId: string,
	params?: GetDestinationDeliveriesParams
) => {
	return [
		'analytics',
		'workbench',
		'destinations',
		destinationId,
		'deliveries',
		...(params ? [params] : [])
	] as const;
};

export const getGetDestinationDeliveriesQueryOptions = <
	TData = Awaited<ReturnType<typeof getDestinationDeliveries>>,
	TError = ErrorType<PraetoidError>
>(
	destinationId: string,
	params?: GetDestinationDeliveriesParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDestinationDeliveries>>, TError, TData>
		>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetDestinationDeliveriesQueryKey(destinationId, params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getDestinationDeliveries>>> = () =>
		getDestinationDeliveries(destinationId, params);

	return { queryKey, queryFn, enabled: !!destinationId, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getDestinationDeliveries>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDestinationDeliveriesQueryResult = NonNullable<
	Awaited<ReturnType<typeof getDestinationDeliveries>>
>;
export type GetDestinationDeliveriesQueryError = ErrorType<PraetoidError>;

export function useGetDestinationDeliveries<
	TData = Awaited<ReturnType<typeof getDestinationDeliveries>>,
	TError = ErrorType<PraetoidError>
>(
	destinationId: string,
	params: undefined | GetDestinationDeliveriesParams,
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDestinationDeliveries>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getDestinationDeliveries>>,
					TError,
					Awaited<ReturnType<typeof getDestinationDeliveries>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDestinationDeliveries<
	TData = Awaited<ReturnType<typeof getDestinationDeliveries>>,
	TError = ErrorType<PraetoidError>
>(
	destinationId: string,
	params?: GetDestinationDeliveriesParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDestinationDeliveries>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getDestinationDeliveries>>,
					TError,
					Awaited<ReturnType<typeof getDestinationDeliveries>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDestinationDeliveries<
	TData = Awaited<ReturnType<typeof getDestinationDeliveries>>,
	TError = ErrorType<PraetoidError>
>(
	destinationId: string,
	params?: GetDestinationDeliveriesParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDestinationDeliveries>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get destination delivery attempts
 */

export function useGetDestinationDeliveries<
	TData = Awaited<ReturnType<typeof getDestinationDeliveries>>,
	TError = ErrorType<PraetoidError>
>(
	destinationId: string,
	params?: GetDestinationDeliveriesParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDestinationDeliveries>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetDestinationDeliveriesQueryOptions(destinationId, params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns delivery health metrics for a specific destination.
 * @summary Get destination health summary
 */
export const getWorkbenchDestinationHealth = (
	destinationId: string,
	params: GetWorkbenchDestinationHealthParams
) => {
	return customInstance<DestinationHealthSummary>({
		url: `/analytics/workbench/destinations/${destinationId}/health`,
		method: 'GET',
		params
	});
};

export const getGetWorkbenchDestinationHealthQueryKey = (
	destinationId: string,
	params?: GetWorkbenchDestinationHealthParams
) => {
	return [
		'analytics',
		'workbench',
		'destinations',
		destinationId,
		'health',
		...(params ? [params] : [])
	] as const;
};

export const getGetWorkbenchDestinationHealthQueryOptions = <
	TData = Awaited<ReturnType<typeof getWorkbenchDestinationHealth>>,
	TError = ErrorType<PraetoidError>
>(
	destinationId: string,
	params: GetWorkbenchDestinationHealthParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getWorkbenchDestinationHealth>>, TError, TData>
		>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetWorkbenchDestinationHealthQueryKey(destinationId, params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkbenchDestinationHealth>>> = () =>
		getWorkbenchDestinationHealth(destinationId, params);

	return { queryKey, queryFn, enabled: !!destinationId, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getWorkbenchDestinationHealth>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetWorkbenchDestinationHealthQueryResult = NonNullable<
	Awaited<ReturnType<typeof getWorkbenchDestinationHealth>>
>;
export type GetWorkbenchDestinationHealthQueryError = ErrorType<PraetoidError>;

export function useGetWorkbenchDestinationHealth<
	TData = Awaited<ReturnType<typeof getWorkbenchDestinationHealth>>,
	TError = ErrorType<PraetoidError>
>(
	destinationId: string,
	params: GetWorkbenchDestinationHealthParams,
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getWorkbenchDestinationHealth>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getWorkbenchDestinationHealth>>,
					TError,
					Awaited<ReturnType<typeof getWorkbenchDestinationHealth>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetWorkbenchDestinationHealth<
	TData = Awaited<ReturnType<typeof getWorkbenchDestinationHealth>>,
	TError = ErrorType<PraetoidError>
>(
	destinationId: string,
	params: GetWorkbenchDestinationHealthParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getWorkbenchDestinationHealth>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getWorkbenchDestinationHealth>>,
					TError,
					Awaited<ReturnType<typeof getWorkbenchDestinationHealth>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetWorkbenchDestinationHealth<
	TData = Awaited<ReturnType<typeof getWorkbenchDestinationHealth>>,
	TError = ErrorType<PraetoidError>
>(
	destinationId: string,
	params: GetWorkbenchDestinationHealthParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getWorkbenchDestinationHealth>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get destination health summary
 */

export function useGetWorkbenchDestinationHealth<
	TData = Awaited<ReturnType<typeof getWorkbenchDestinationHealth>>,
	TError = ErrorType<PraetoidError>
>(
	destinationId: string,
	params: GetWorkbenchDestinationHealthParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getWorkbenchDestinationHealth>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetWorkbenchDestinationHealthQueryOptions(destinationId, params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns delivery timeseries for a specific destination.
 * @summary Get destination delivery timeseries
 */
export const getWorkbenchDestinationPerformance = (
	destinationId: string,
	params: GetWorkbenchDestinationPerformanceParams
) => {
	return customInstance<DestinationPerformanceResponse>({
		url: `/analytics/workbench/destinations/${destinationId}/performance`,
		method: 'GET',
		params
	});
};

export const getGetWorkbenchDestinationPerformanceQueryKey = (
	destinationId: string,
	params?: GetWorkbenchDestinationPerformanceParams
) => {
	return [
		'analytics',
		'workbench',
		'destinations',
		destinationId,
		'performance',
		...(params ? [params] : [])
	] as const;
};

export const getGetWorkbenchDestinationPerformanceQueryOptions = <
	TData = Awaited<ReturnType<typeof getWorkbenchDestinationPerformance>>,
	TError = ErrorType<PraetoidError>
>(
	destinationId: string,
	params: GetWorkbenchDestinationPerformanceParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getWorkbenchDestinationPerformance>>, TError, TData>
		>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetWorkbenchDestinationPerformanceQueryKey(destinationId, params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getWorkbenchDestinationPerformance>>
	> = () => getWorkbenchDestinationPerformance(destinationId, params);

	return { queryKey, queryFn, enabled: !!destinationId, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getWorkbenchDestinationPerformance>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetWorkbenchDestinationPerformanceQueryResult = NonNullable<
	Awaited<ReturnType<typeof getWorkbenchDestinationPerformance>>
>;
export type GetWorkbenchDestinationPerformanceQueryError = ErrorType<PraetoidError>;

export function useGetWorkbenchDestinationPerformance<
	TData = Awaited<ReturnType<typeof getWorkbenchDestinationPerformance>>,
	TError = ErrorType<PraetoidError>
>(
	destinationId: string,
	params: GetWorkbenchDestinationPerformanceParams,
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getWorkbenchDestinationPerformance>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getWorkbenchDestinationPerformance>>,
					TError,
					Awaited<ReturnType<typeof getWorkbenchDestinationPerformance>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetWorkbenchDestinationPerformance<
	TData = Awaited<ReturnType<typeof getWorkbenchDestinationPerformance>>,
	TError = ErrorType<PraetoidError>
>(
	destinationId: string,
	params: GetWorkbenchDestinationPerformanceParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getWorkbenchDestinationPerformance>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getWorkbenchDestinationPerformance>>,
					TError,
					Awaited<ReturnType<typeof getWorkbenchDestinationPerformance>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetWorkbenchDestinationPerformance<
	TData = Awaited<ReturnType<typeof getWorkbenchDestinationPerformance>>,
	TError = ErrorType<PraetoidError>
>(
	destinationId: string,
	params: GetWorkbenchDestinationPerformanceParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getWorkbenchDestinationPerformance>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get destination delivery timeseries
 */

export function useGetWorkbenchDestinationPerformance<
	TData = Awaited<ReturnType<typeof getWorkbenchDestinationPerformance>>,
	TError = ErrorType<PraetoidError>
>(
	destinationId: string,
	params: GetWorkbenchDestinationPerformanceParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getWorkbenchDestinationPerformance>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetWorkbenchDestinationPerformanceQueryOptions(
		destinationId,
		params,
		options
	);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns API request timeseries/summary and delivery timeseries for the workbench.
 * @summary Get workbench overview
 */
export const getWorkbenchOverview = (params: GetWorkbenchOverviewParams) => {
	return customInstance<WorkbenchOverviewResponse>({
		url: `/analytics/workbench/overview`,
		method: 'GET',
		params
	});
};

export const getGetWorkbenchOverviewQueryKey = (params?: GetWorkbenchOverviewParams) => {
	return ['analytics', 'workbench', 'overview', ...(params ? [params] : [])] as const;
};

export const getGetWorkbenchOverviewQueryOptions = <
	TData = Awaited<ReturnType<typeof getWorkbenchOverview>>,
	TError = ErrorType<PraetoidError>
>(
	params: GetWorkbenchOverviewParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getWorkbenchOverview>>, TError, TData>
		>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetWorkbenchOverviewQueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkbenchOverview>>> = () =>
		getWorkbenchOverview(params);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getWorkbenchOverview>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetWorkbenchOverviewQueryResult = NonNullable<
	Awaited<ReturnType<typeof getWorkbenchOverview>>
>;
export type GetWorkbenchOverviewQueryError = ErrorType<PraetoidError>;

export function useGetWorkbenchOverview<
	TData = Awaited<ReturnType<typeof getWorkbenchOverview>>,
	TError = ErrorType<PraetoidError>
>(
	params: GetWorkbenchOverviewParams,
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getWorkbenchOverview>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getWorkbenchOverview>>,
					TError,
					Awaited<ReturnType<typeof getWorkbenchOverview>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetWorkbenchOverview<
	TData = Awaited<ReturnType<typeof getWorkbenchOverview>>,
	TError = ErrorType<PraetoidError>
>(
	params: GetWorkbenchOverviewParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getWorkbenchOverview>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getWorkbenchOverview>>,
					TError,
					Awaited<ReturnType<typeof getWorkbenchOverview>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetWorkbenchOverview<
	TData = Awaited<ReturnType<typeof getWorkbenchOverview>>,
	TError = ErrorType<PraetoidError>
>(
	params: GetWorkbenchOverviewParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getWorkbenchOverview>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get workbench overview
 */

export function useGetWorkbenchOverview<
	TData = Awaited<ReturnType<typeof getWorkbenchOverview>>,
	TError = ErrorType<PraetoidError>
>(
	params: GetWorkbenchOverviewParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getWorkbenchOverview>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetWorkbenchOverviewQueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}
